import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TripIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TripIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.82348 3.46394C5.65247 3.46394 5.51383 3.60257 5.51383 3.77359V5.23217C5.51383 5.40319 5.65247 5.54182 5.82348 5.54182H18.18C18.351 5.54182 18.4896 5.40319 18.4896 5.23217V3.77359C18.4896 3.60257 18.351 3.46394 18.18 3.46394H5.82348ZM4.04989 3.77359C4.04989 2.79406 4.84396 2 5.82348 2H18.18C19.1595 2 19.9536 2.79406 19.9536 3.77359V5.23217C19.9536 6.2117 19.1595 7.00576 18.18 7.00576H5.82348C4.84396 7.00576 4.04989 6.2117 4.04989 5.23217V3.77359Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.57337 6.27379C5.57337 5.86954 5.90108 5.54182 6.30534 5.54182H17.6981C18.1024 5.54182 18.4301 5.86954 18.4301 6.27379V9.89014C18.4301 11.4442 17.1689 12.7054 15.6149 12.7054H8.38858C6.83455 12.7054 5.57336 11.4442 5.57336 9.89014L5.57337 6.27379ZM7.0373 7.00576L7.03729 9.89014C7.03729 10.6357 7.64306 11.2414 8.38858 11.2414H15.6149C16.3604 11.2414 16.9662 10.6357 16.9662 9.89014V7.00576H7.0373Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.08343 12.7054C7.91241 12.7054 7.77377 12.844 7.77377 13.015V20.2264C7.77377 20.3974 7.91241 20.5361 8.08343 20.5361H15.9201C16.0911 20.5361 16.2297 20.3974 16.2297 20.2264V13.015C16.2297 12.844 16.0911 12.7054 15.9201 12.7054H8.08343ZM6.30983 13.015C6.30983 12.0355 7.1039 11.2414 8.08343 11.2414H15.9201C16.8996 11.2414 17.6937 12.0355 17.6937 13.015V20.2264C17.6937 21.2059 16.8996 22 15.9201 22H8.08343C7.1039 22 6.30983 21.2059 6.30983 20.2264V13.015Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2281 13.7332C16.2281 13.3289 16.5558 13.0012 16.9601 13.0012H18.9957C19.9749 13.0012 20.7693 13.7956 20.7693 14.7748V17.868C20.7693 18.8472 19.9749 19.6416 18.9957 19.6416H16.9601C16.5558 19.6416 16.2281 19.3139 16.2281 18.9097V13.7332ZM17.6921 14.4651V18.1777H18.9957C19.1664 18.1777 19.3054 18.0387 19.3054 17.868V14.7748C19.3054 14.6041 19.1664 14.4651 18.9957 14.4651H17.6921Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.77217 18.9097C7.77217 19.3139 7.44446 19.6416 7.0402 19.6416H5.00455C4.0254 19.6416 3.23096 18.8472 3.23096 17.868V14.7748C3.23096 13.7956 4.0254 13.0012 5.00455 13.0012H7.0402C7.44446 13.0012 7.77217 13.3289 7.77217 13.7332V18.9097ZM6.30823 18.1777V14.4651H5.00455C4.83391 14.4651 4.6949 14.6041 4.6949 14.7748V17.868C4.6949 18.0387 4.83391 18.1777 5.00455 18.1777H6.30823Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2047 2C14.609 2 14.9367 2.32771 14.9367 2.73197V13.9875C14.9367 14.3917 14.609 14.7195 14.2047 14.7195C13.8005 14.7195 13.4728 14.3917 13.4728 13.9875V2.73197C13.4728 2.32771 13.8005 2 14.2047 2Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4255 9.12359C12.4255 8.71934 12.7533 8.39163 13.1575 8.39163H15.252C15.6562 8.39163 15.9839 8.71934 15.9839 9.12359C15.9839 9.52785 15.6562 9.85556 15.252 9.85556H13.1575C12.7533 9.85556 12.4255 9.52785 12.4255 9.12359Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.79874 2C10.203 2 10.5307 2.32771 10.5307 2.73197V13.9875C10.5307 14.3917 10.203 14.7195 9.79874 14.7195C9.39449 14.7195 9.06677 14.3917 9.06677 13.9875V2.73197C9.06677 2.32771 9.39449 2 9.79874 2Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.01955 9.12359C8.01955 8.71934 8.34726 8.39163 8.75152 8.39163H10.846C11.2502 8.39163 11.5779 8.71934 11.5779 9.12359C11.5779 9.52785 11.2502 9.85556 10.846 9.85556H8.75152C8.34726 9.85556 8.01955 9.52785 8.01955 9.12359Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1631 17.9553C13.3338 17.9553 13.4728 17.8162 13.4728 17.6456V17.0534H10.3312V17.6456C10.3312 17.8162 10.4702 17.9553 10.6408 17.9553H13.1631ZM14.9367 17.6456C14.9367 18.6247 14.1423 19.4192 13.1631 19.4192H10.6408C9.66168 19.4192 8.86723 18.6247 8.86723 17.6456V16.3214C8.86723 15.9172 9.19494 15.5895 9.5992 15.5895H14.2047C14.609 15.5895 14.9367 15.9172 14.9367 16.3214V17.6456Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default TripIcon;
